import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { Row, Card, CardBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import moment from 'moment';
import CustomFormGroup from 'Components/CustomFormGroup';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import LoadingOverlay from 'Components/LoadingOverlay';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import { NotificationManager } from 'Components/ReactNotifications';
import IntlMessages from 'Util/IntlMessages';
import {
	purposesCreate,
	purposesUpdate,
	purposesGetDetails,
	purposesGetOptions,
	errorReset,
} from 'Redux/actions';
import * as purposesReducer from 'Redux/purposes/reducer';

class PageConfigPurpose extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			purpose: new Map({
				id: null,
				status: 1,
				name: '',
				description: '',
				remark: '',
			}),
		};
		this.fields = [
			{ id: 'status', type: 'react-select', label: 'Status', onChange: this.onChangeStatusHandler.bind(this) },
			{ id: 'name', type: 'text', label: 'Name', extraProps: { maxLength: 255 } },
			{ id: 'description', type: 'text', label: 'Description', extraProps: { maxLength: 255 } },
			{ id: 'remark', type: 'text', label: 'Remark', extraProps: { maxLength: 255 } },
		];
		this.breadcrumb = [
			{ id: 'menu.config' },
			{ id: 'menu.config.purposes', href: '/config/purposes' },
			{ id: 'config.purpose.heading', href: `/config/purposes/${this.getId(props) ? `edit/${this.getId(props)}` : 'create'}` },
		];
		this.getId = this.getId.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
	}

	componentDidMount() {
		const id = this.getId();
		if (id) {
			this.props.purposesGetDetails(id);
		}
		this.props.purposesGetOptions();
		this.props.errorReset('purpose');
	}

	componentDidUpdate(prevProps) {
		const id = this.getId();
		if (id) {
			const prevPurpose = prevProps.purpose.get(id);
			const purpose = this.props.purpose.get(id);
			if (purpose && purpose !== prevPurpose) {
				this.setState({
					purpose: this.state.purpose.merge(purpose),
				});
			}
		}

		const current = this.props.current;
		const prevStatus = prevProps.status.get('purpose');
		const status = this.props.status.get('purpose');
		if (status && prevStatus !== status) {
			switch (status) {
			case 'submitted': {
				NotificationManager.success(
					`The purpose is ${id ? 'updated' : 'created'} successfully.`,
					`Purpose ${id ? 'Updated' : 'Created'}`
				);
				this.props.history.push(`/app/config/purposes/edit/${current}`);
				const purpose = this.props.purpose.get(current);
				this.setState({
					purpose: this.state.purpose.merge(purpose),
				});
			}
				break;
			case 'has-errors':
				NotificationManager.error(
					`Error occured! The purpose is NOT ${id ? 'updated' : 'created'}.`,
					`Purpose ${id ? 'Updated' : 'Created'} Failed`
				);
				break;
			}
		}
	}

	getId(props = null) {
		if (!props) {
			props = this.props;
		}
		return parseInt(props.match.params.id);
	}

	onChangeHandler(e) {
		const { purpose } = this.state;
		this.setState({
			purpose: purpose.set(e.target.id, e.target.value),
		});
	}

	onChangeStatusHandler(selectedOption) {
		let { purpose } = this.state;
		this.setState({
			purpose: purpose.set('status', selectedOption),
		});
	}

	onSubmitHandler(e) {
		e.preventDefault();
		const id = this.getId();
		let purpose = this.state.purpose.toJS();
		purpose.status = purpose.status ? purpose.status.value : null;
		if (!id) {
			this.props.purposesCreate(purpose);
		} else {
			this.props.purposesUpdate(purpose);
		}
	}

	render() {
		const { options, errors } = this.props;
		const { purpose } = this.state;
		const id = this.getId();
		const status = this.props.status.get('purpose');
		const optionsStatus = this.props.status.get('options');
		const isLoading = status === 'fetching' || status === 'submitting' || optionsStatus === 'fetching';
		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<BreadcrumbContainer
							heading={ <IntlMessages id="config.purpose.heading" /> }
							items={ this.breadcrumb }
							match={ this.props.match }
						/>
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<Form onSubmit={ this.onSubmitHandler }>
					<Row>
						<Colxx xxs="12">
							<Card>
								<LoadingOverlay active={ isLoading }>
									<CardBody>
										{
											!!id && (
												<FormGroup>
													<Label for="id">ID</Label>
													<Input
														type="text"
														id="id"
														value={ purpose.get('id') || '' }
														disabled={ isLoading }
														readOnly
													/>
												</FormGroup>
											)
										}
										{
											this.fields.map((field) => (
												<CustomFormGroup
													key={ `page-config-purpose-${field.id}` }
													id={ field.id }
													label={ field.label }
													type={ field.type }
													value={ purpose.get(field.id) }
													disabled={ isLoading }
													errors={ errors && errors.detail[field.id] }
													onChange={ field.onChange ? field.onChange : this.onChangeHandler }
													options={ options.get(field.id) }
													isMulti={ field.isMulti }
													extraProps={ field.extraProps }
												/>
											))
										}

										{
											purpose.get('updated_on') && (
												<p>Updated at { moment(purpose.get('updated_on')).format('YYYY-MM-DD HH:mm:ss') }</p>
											)
										}

										<div className="mt-4 text-center">
											<Button size="lg" color="primary" onClick={ this.onSubmitHandler } disabled={ isLoading }>
												SAVE
											</Button>
										</div>
									</CardBody>
								</LoadingOverlay>
							</Card>
						</Colxx>
					</Row>
				</Form>
			</Fragment>
		);
	}
}

export default connect(
	purposesReducer.selector,
	{
		purposesCreate,
		purposesUpdate,
		purposesGetDetails,
		purposesGetOptions,
		errorReset,
	}
)(PageConfigPurpose);